module.exports = __webpack_public_path__ + "media/images/logo-all-667a476464299b185772f9a18a7a3637.svg";